<template>
    <div>
        <messaging :display="message.display" :bottom="true" :text="message.text" :timeout="message.timeout" v-on:closed="message.display=false"/>

        <v-dialog
            v-model="$store.getters.overlays.editProfile"
            :fullscreen="windowSize.width<=800 || windowSize.height <=700"
            content-class="editProfileDialog"
            scrollable
            width="1100"
            :persistent="isModal"
        >   
            <userFormEditProfile :user="user" v-on:saveEditProfile="saveEditProfile" v-on:close="$emit('close')" v-on:failedPasswordValidation="failedValidationMessage"/>
        </v-dialog>
    </div>
</template>

<script>
import userFormEditProfile from '@/components/Forms/userFormEditProfile.vue';
import HubspotReflectionPoolHandler from '@/Controllers/helper/HubspotReflectionPoolHandler.js'

export default {
    name: "EditProfile",
    components: {
        userFormEditProfile
    },
    data: function() {
        return {
            message: {
                display: false,
                text: 'sample text',
                timeout: null
            },
        }
    },
    methods: {
        saveEditProfile: function(user_package) {
            this.update_user(user_package);
        },
        update_user: function(user_data){
            let self = this;
            let wrap_user_data = this.unlink(user_data.user);
            if(user_data.password) {
                wrap_user_data.password = user_data.password;
            }       
            this.$controller.security.user.edit_user(wrap_user_data).then(function(response) {
                if(response) {
                    self.editProfile_onSuccess();
                    self.$store.dispatch('user',wrap_user_data);
                    self.$emit('close');
                    let hubspotFeed = HubspotReflectionPoolHandler.event.addFeed(wrap_user_data, "user_profile_update", self)
                } else {
                    self.editProfile_onFailure();
                }
            });
        },
        editProfile_onSuccess: function(){
            this.customCLog('editProfile success');
            this.message.text = this.labels('message > editProfile success');
            this.message.display = true;
        },
        editProfile_onFailure: function(){
            this.customCLog('editProfile failure');
            this.message.text = this.labels('message > editProfile failure');
            this.message.display = true;
        },
        failedValidationMessage: function() {
            this.customCLog("Failed Password Validation");
            this.message.text = this.labels('message > editProfile validation_failure_password');
            this.message.display = true;
        }
    },
    computed: {
        isModal: function(){
            return this.firstMigratedUserLogin();
        },
        user: function() {
            return this.$store.getters.user ? this.$store.getters.user : {}
        },
        windowSize: function() {
            return this.$store.getters.window;
        }
    }
}
</script>

<style scroped>
.editProfileDialog {
    background-color:white;
}
</style>